<tds-app-shell class="psf-fade-in-animation-150">
  <app-toast-displayer></app-toast-displayer>
  <header tds-header>
    <div
      tds-header-app-name
      name="{{ appName }}"
      (click)="navigateToHomePage()"
      (keyUp)="navigateToHomePage()"
      class="pointer"
    >
      <img src="assets/images/psf_logo.svg" alt="" tds-header-app-logo width="40" height="40" />
    </div>

    <tds-header-center>
      <ng-container *ngTemplateOutlet="navigation" />
    </tds-header-center>

    <tds-header-end>
      <button tds-icon-button size="lg" label="GRP">
        <a
          target="_blank"
          href="https://totalworkplace.sharepoint.com/sites/Intelligence/Longterm%20Power%20Price%20Scenarios/Forms/AllItems.aspx"
        >
          <tds-icon name="search"></tds-icon>
        </a>
      </button>
      @if((connectedUser | async)?.roles?.includes(Roles.ADMIN)
      || (connectedUser | async)?.roles?.includes(Roles.USER)) {
        <button tds-icon-button size="lg" label="alert" (click)="openNotificationModal()">
          <tds-icon name="notifications"></tds-icon>
        </button>
        <button tds-icon-button size="lg" label="Request hourly data" (click)="openHourlyDataRequestModal()">
          <tds-icon name="database"></tds-icon>
        </button>
      }
      @if((connectedUser | async)?.roles?.includes(Roles.ADMIN)){
        <button
          tds-icon-button
          size="lg"
          label="Settings"
          (click)="navigateToSettingsPage()"
        >
          <tds-icon name="settings"></tds-icon>
        </button>
      }
    </tds-header-end>

    <tds-header-mobile-menu #menu>
      <tds-header-mobile-menu-start>
        <div class="header-mobile-menu">
          <tds-form-field>
            <tds-search tds-form-field-item>
              <input
                type="search"
                tds-search-input
                placeholder="Search"
                aria-label="Search"
                (blur)="menu.closeMenu()"
              />
            </tds-search>
          </tds-form-field>
          <div class="userinfo">
            <tds-icon name="account_circle"></tds-icon>
            {{ (connectedUser | async)?.username }}
          </div>
        </div>
        <ng-container *ngTemplateOutlet="navigation" />
      </tds-header-mobile-menu-start>
      <tds-header-mobile-menu-end>
        <button tds-header-mobile-menu-action [shouldCloseMenuOnClick]="true">
          <tds-icon name="close"></tds-icon>
          Close menu
        </button>
        <button tds-header-mobile-menu-action (click)="logout()" (keyUp)="logout()">
          <tds-icon name="logout"></tds-icon>
          Logout
        </button>
      </tds-header-mobile-menu-end>
    </tds-header-mobile-menu>

    <ng-template #navigation>
      <nav tds-header-navigation aria-label="Navigation menu">
        @if((connectedUser | async)?.roles?.includes(Roles.PC_ADMIN) || (connectedUser | async)?.roles?.includes(Roles.PC_USER)) {
          <a tds-header-navigation-link routerLink="price-card" routerLinkActive>Price Card</a>
        }
        @if((connectedUser | async)?.roles?.includes(Roles.USER) || (connectedUser | async)?.roles?.includes(Roles.ADMIN)) {
            <a tds-header-navigation-link routerLink="finder" routerLinkActive>Price Scenario</a>
        }
        <a tds-header-navigation-link routerLink="info" routerLinkActive>Info & Contact</a>
      </nav>
    </ng-template>
  </header>

  <router-outlet></router-outlet>
</tds-app-shell>
